import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

// const match = window.location.hash.match(/[?&]token=([^&]+)/);
// const btoken =  match ? match[1] : '';
// console.log('___lotoken', btoken)
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    // 'token': btoken || localStorage.getItem("token"),
    'token': localStorage.getItem("token"),
    //'server':1
  },
  timeout: 15000 // request timeout 设置请求超时时间，单位（毫秒）
})

// response interceptor 响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data // response.data里面的数据才是后台返回给我们的数据  200  500
    // 200  500 后端这几个特定异常判断没有问题后，才能放行，进行相应数据
   if (res.code === 500) {
      Notification.error({
        title: '服务器内部出现异常，请联系管理员'
      })
      return Promise.reject('error')// 记录错误
    } else if (res.code === 400) { // 可能是其它参数出错
      Notification.error({
        title: res.msg
      })
      return Promise.reject('error')// 记录错误
    } else if (res.status == -10000) {
      Message({
        message: '验证登录已过期或账号在别处登录',
        type: 'warning'
      });
      router.push('/login') 
      return Promise.reject('error')// 记录错误
    } else {
      // 以上验证通过之后再放行
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      //message: error.message,
      message: "请检查网络设置",
      showClose: true,
      dangerouslyUseHTMLString: true,
      type: 'error',
      duration: 10 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
